import { useContent } from '@/content'
import { useDocumentMeta } from '@/hooks'
import { ROUTES } from '@/lib/paths'
import { Button, Section } from '@/components/ui'
import styles from './NotFoundPage.module.css'

/** Fallback for any unmatched route. */
export const NotFoundPage = () => {
  const { site } = useContent()
  useDocumentMeta({ title: `Page not found — ${site.name}` })

  return (
    <Section>
      <div className={styles.page}>
        <p className={styles.code}>404</p>
        <div className={styles.body}>
          <h1 className={`t-24 ${styles.title}`}>Page not found</h1>
          <p className={styles.description}>
            The page you were looking for has moved or never existed.
          </p>
        </div>
        <Button to={ROUTES.home} icon="arrowUpRight">
          Back to home
        </Button>
      </div>
    </Section>
  )
}
